import { IApplicationState, TActivityId } from '../../../../../../../types/types';

export const getCardLastClickedActivityId = (
    state: IApplicationState
): TActivityId => {
    return state.cardPanel && state.cardPanel.cardActivity && state.cardPanel.cardActivity.lastClickedActivityId;
}
